import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import ErrorBoundary from 'components/common/utilities/error_boundary';
import { ReactCardRenderer } from '@gladly/card-renderer';
import BubbleContent from '../content/bubble_content';
import { getCardRendererHostConfig } from 'components/lib/card_renderer_host_config';
import RedactedItem from 'components/customer/conversation_history/conversation_items_v2/redacted_item';
import ConversationItem from 'models/conversation_item';

const baseHostAppConfig = {
  defaults: {
    card: {
      background: 'transparent',
      padding: 'none',
      borderRadius: 'none',
      borderWidth: 'none',
      elevation: 'none',
    },
  },
};

export default function ChatTemplatedCardContent({ className, item, status, withoutBubble }) {
  const body = renderBody(item);

  return withoutBubble ? (
    body
  ) : (
    <BubbleContent
      className={classnames('chatItem-content flexible-card', className)}
      data-aid={`chatItem-content-${item.id}`}
      item={item}
      status={status}
    >
      {renderBody(item)}
    </BubbleContent>
  );
}

function renderBody(item) {
  if (item.content.isRedacted) {
    return <RedactedItem />;
  }

  const messageData = item.content.messageData;
  return (
    <ErrorBoundary
      errorMeta={{ errorBoundary: 'Templated Card' }}
      renderError={() => (
        <ChatTemplatedCardError>
          <Trans>Unsupported template structure</Trans>
        </ChatTemplatedCardError>
      )}
    >
      <ReactCardRendererContainer>
        <ReactCardRenderer
          data={messageData.data}
          hostConfig={getCardRendererHostConfig(baseHostAppConfig)}
          template={messageData.template}
        />
      </ReactCardRendererContainer>
    </ErrorBoundary>
  );
}

ChatTemplatedCardContent.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  status: PropTypes.string,
  withoutBubble: PropTypes.bool,
};

const ReactCardRendererContainer = styled.div`
  min-width: 250px;
  max-width: 300px;
  white-space: normal;
`;

const ChatTemplatedCardError = styled.div`
  color: red;
  font-size: var(--font-size-reduced);
  text-align: center;
`;
